import { useGetConfiguration } from './useGetConfiguration';

export const useGetConfigurationFeatures = () => {
  const { data, ...rest } = useGetConfiguration();

  return {
    data: data?.features,
    ...rest,
  };
};
